import type { Route } from '~/interfaces/routes.interfaces'

export const SEARCH_OPOINT: Route = {
    path: '/search/opoint'
}

export const SEARCH_AFP: Route = {
    path: '/search/afp'
}